import { DownArrowIcon } from '@sketchnote/icons';
import * as React from 'react';

import { MenuItemProps, MoreActionMenu } from '../more-menu';
const { useState } = React;

export const AccessDropdownMenu = ({ title, subTitle }: { title: string; subTitle?: string }) => (
  <>
    <p>{title}</p>
    <p className="text-gray-500 font-regular">{subTitle}</p>
  </>
);

export const AccessDropdown = ({
  menuItems,
  onClickMenuItem,
  accessLevel = '',
  isReadOnly = false,
}: {
  menuItems: { title: string; subTitle?: string; value: string }[];
  onClickMenuItem?: (value: string) => void;
  accessLevel?: string;
  isReadOnly?: boolean;
}) => {
  const [access, setAccess] = useState(accessLevel ? accessLevel : menuItems[0].value);

  const handleMenuClick = (menuitem: MenuItemProps) => {
    if (onClickMenuItem && menuitem.value) {
      onClickMenuItem(menuitem.value);
    }
    if (menuitem.value === 'admin' || menuitem.value === 'member') {
      setAccess(menuitem.value);
    }
  };

  return (
    <div className="flex text-gray-600 items-center text-sm">
      <span className="mr-8">{menuItems.find((item) => item.value === access)?.title}</span>
      {menuItems.find((item) => item.value === access)?.title ? (
        <MoreActionMenu
          disabled={isReadOnly}
          menuItems={menuItems.map((item) => ({
            label: <AccessDropdownMenu title={item.title} subTitle={item?.subTitle} />,
            value: item.value,
            isActive: item.value === access,
          }))}
          icon={!isReadOnly ? <DownArrowIcon wrapperClass="mt-4" /> : <></>}
          onClickMenuItem={handleMenuClick}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
